var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"type"},[_c('ul',_vm._l((_vm.typeList),function(v,i){return _c('li',{key:i,class:{active:_vm.index==i},on:{"click":function($event){return _vm.typeChange(v,i)}}},[_vm._v(_vm._s(v.name))])}),0)]),_c('div',{attrs:{"id":"sortCount"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }